import { render, staticRenderFns } from "./CalcPaperBug.vue?vue&type=template&id=65d85f4a&"
import script from "./CalcPaperBug.vue?vue&type=script&lang=js&"
export * from "./CalcPaperBug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports